// extracted by mini-css-extract-plugin
export default {"applicationItem":"styles_applicationItem__XzGa0"};